import { URLs } from "common/lib/constants";

export interface IBackNavigationRule {
  pattern: string;
  destination: string;
}

export const BACK_NAVIGATION_RULES: IBackNavigationRule[] = [
  {
    pattern: "/my-applications/new-liquidity-request/thank_you_application",
    destination: URLs.PROTECTED.DASHBOARD,
  },
  {
    pattern: "/my-applications/*/application-status",
    destination: URLs.PROTECTED.DASHBOARD,
  },
  {
    pattern: "/my-applications/*/assets-included",
    destination: URLs.PROTECTED.DASHBOARD,
  },
  {
    pattern: "/my-applications/new-altquote",
    destination: URLs.PROTECTED.DASHBOARD,
  },
  {
    pattern: "/my-applications/*/altquote",
    destination: URLs.PROTECTED.DASHBOARD,
  },
  {
    pattern: "/my-applications/*/altquote-assets-included",
    destination: URLs.PROTECTED.DASHBOARD,
  },
  {
    pattern: "/dashboard/liquidity/custody-account-id",
    destination: URLs.PROTECTED.DASHBOARD,
  },
  {
    pattern: "/my_assets/asset_documents",
    destination: URLs.PROTECTED.DASHBOARD,
  },
];

